import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@/Components/ui';
import type { ChangelogBlock } from './changelog';

interface ChangelogModalProps {
  isOpen: boolean;
  blocks: ChangelogBlock[];
  onDismiss: () => void;
}

function renderBlock(block: ChangelogBlock, index: number) {
  if (block.type === 'h1') {
    return <h3 key={index} className="mb-3 text-xl font-semibold text-slate-900">{block.text}</h3>;
  }

  if (block.type === 'h2') {
    return <h4 key={index} className="mt-5 mb-2 text-base font-semibold text-slate-800">{block.text}</h4>;
  }

  if (block.type === 'h3') {
    return <h5 key={index} className="mt-4 mb-2 text-sm font-semibold text-slate-700">{block.text}</h5>;
  }

  if (block.type === 'li') {
    return <li key={index} className="ml-5 list-disc text-sm leading-6 text-slate-700">{block.text}</li>;
  }

  return <p key={index} className="mb-2 text-sm leading-6 text-slate-700">{block.text}</p>;
}

export default function ChangelogModal({ isOpen, blocks, onDismiss }: ChangelogModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onDismiss} size="lg" variant="dialog" scrollable title="CRM 변경사항">
      <ModalHeader toggle={onDismiss}>CRM 변경사항</ModalHeader>
      <ModalBody>
        <div className="space-y-1">{blocks.map(renderBlock)}</div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onDismiss}>확인</Button>
      </ModalFooter>
    </Modal>
  );
}
